//'http://192.168.50.243:3999/',
const prodEnv = {
  API_BASE_URL: process.env.REACT_APP_BASE_URL_LIV,
};
//'http://192.168.1.102:3999/',
const devEnv = {
  API_BASE_URL: process.env.REACT_APP_BASE_URL_TEST,
};

export const getGlobals = () => {
  const currentOrigin = window?.location?.origin;

  if (process.env.NODE_ENV !== "production") {
    return devEnv;
  } else {
    switch (currentOrigin) {
      case "http://sonasgroup.dyndns.org:3050":
        return {
          API_BASE_URL: "http://sonasgroup.dyndns.org:3999/",
        };
      case "http://192.168.50.243:3000":
        return {
          API_BASE_URL: "http://192.168.50.243:3999/",
        };
      default:
        return prodEnv;
    }
  }
};

export const userBased_HideField = () => {
  if (
    getGlobals().API_BASE_URL === "http://192.168.50.243:3999/"
    // || getGlobals().API_BASE_URL === "http://192.168.1.102:3999/"
  ) {
    return true;
  } else {
    return false;
  }
};

export const getMUILicensekey = () => {
  // console.log("MUILicensekey", process.env.REACT_APP_MUI_DATAGRID_PRO);

  return process.env.REACT_APP_MUI_DATAGRID_PRO;
};
